import { render, staticRenderFns } from "./ActiveSign.vue?vue&type=template&id=3f525777&"
import script from "./ActiveSign.vue?vue&type=script&lang=js&"
export * from "./ActiveSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f525777')) {
      api.createRecord('3f525777', component.options)
    } else {
      api.reload('3f525777', component.options)
    }
    module.hot.accept("./ActiveSign.vue?vue&type=template&id=3f525777&", function () {
      api.rerender('3f525777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/edigital/ActiveSign.vue"
export default component.exports